interface DashboardFooterProps {
  onOpenAbout: () => void;
}

export default function DashboardFooter({ onOpenAbout }: DashboardFooterProps) {
  return (
    <footer className="mx-auto max-w-7xl space-y-6 px-6 py-16 text-center">
      <div className="flex flex-col items-center gap-4">
        <button
          onClick={onOpenAbout}
          className="text-primary hover:text-primary-dark border-primary/20 border-b pb-1 text-xs font-black tracking-widest uppercase transition-colors"
        >
          Read the MMEM Paper Summary
        </button>
        <p className="text-xs font-medium text-slate-400 dark:text-slate-500">
          Quantifying the neurobiology of learning &copy; 2026
        </p>
      </div>
      <div className="text-[10px] font-bold tracking-[0.3em] text-slate-400/50 uppercase">
        Mojolagbe Memory Encoding Model
      </div>
    </footer>
  );
}
